/* Progressive enhancement: guide content and section links work without JavaScript. */
(() => {
  if (window.__evolvedProductHelpV2) return;
  window.__evolvedProductHelpV2 = true;
  const normalize = (value) => String(value || '').normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[\u2019']/g, '')
    .replace(/[^\p{L}\p{N}]+/gu, ' ').replace(/\bcharg(?:e|es|er|ers|ing)\b/g, 'charge').trim();
  const aliases = {
    'charging-troubleshooting': 'iphone wont charge not charging stopped charging hot heat overheating blinking flashing slow disconnecting watch airpods',
    'power-bank-help': 'powerbank battery pack portable charger not charging wont charge dead recharge capacity mah',
    'magsafe-qi2-alignment-help': 'magnet magnetic weak hold ring connection disconnecting qi 2 qi2 magsafe',
    'power-adapter-cable-help': 'usb c usbc power brick plug adapter adaptor wattage pd cable power supply',
    'charging-speed-explained': 'slow speed fast watts wattage charging speed battery 80 percent',
    'device-compatibility': 'compatible compatibility iphone samsung galaxy android ipad apple watch airpods fit',
    'find-your-device-model': 'identify model number a number iphone samsung galaxy ipad watch airpods',
    'led-indicator-light-help': 'led light flashing blinking indicator blue red green light',
    'travel-charging-airline-guide': 'airplane plane flight flying airline airport carry on luggage travel',
    'case-installation-removal': 'case cover fit fitting remove removal installation stuck iphone ipad',
    'magnetic-mount-installation': 'mount holder suction adhesive vent car slips falling setup',
    'product-care-maintenance': 'clean cleaning maintenance wash care storage',
    'warranty-returns-support': 'warranty return refund broken defective damaged replacement support',
    'product-manuals-quick-start': 'manual instructions quickstart quick start setup guide',
    'product-setup-daily-use': 'first use getting started setup install instructions'
  };
  const initialize = (root) => {
    if (!root || root.dataset.helpReady === 'true') return;
    root.dataset.helpReady = 'true';
    const form = root.querySelector('[data-help-search]');
    const input = root.querySelector('[data-help-input]');
    const status = root.querySelector('[data-help-status]');
    const clear = root.querySelector('[data-help-clear]');
    const cards = Array.from(root.querySelectorAll('.ev-product-help__links > a'));
    const groups = Array.from(root.querySelectorAll('[data-help-topic]')).filter((group) => group.querySelector('.ev-product-help__links'));
    let index = [];
    try { index = JSON.parse(root.querySelector('[data-help-index]')?.textContent || '{"pages":[]}').pages || []; } catch (_) { /* Card text remains searchable. */ }
    const records = cards.map((card) => {
      const path = new URL(card.getAttribute('href'), document.baseURI).pathname;
      const handle = path.split('/').filter(Boolean).pop();
      const text = index.find((entry) => entry.path === path || entry.path.endsWith('/' + handle))?.text || '';
      return {card, corpus: normalize(card.textContent + ' ' + text + ' ' + (aliases[handle] || ''))};
    });
    const filter = () => {
      if (!input || !status) return cards.length;
      const query = normalize(input.value);
      const terms = query.split(' ').filter(Boolean);
      let count = 0;
      records.forEach(({card, corpus}) => {
        const match = terms.every((term) => corpus.includes(term));
        card.hidden = !match;
        if (match) count += 1;
      });
      groups.forEach((group) => {
        group.hidden = !!query && !Array.from(group.querySelectorAll('.ev-product-help__links > a')).some((card) => !card.hidden);
      });
      if (clear) clear.hidden = !input.value;
      status.textContent = !query ? `${cards.length} guides available.` : count
        ? `${count} ${count === 1 ? 'guide' : 'guides'} found for "${input.value.trim()}".`
        : 'No matching guides. Try fewer words, or contact support below.';
      return count;
    };
    const reset = () => { if (input) { input.value = ''; filter(); } };
    const jumpTo = (target) => {
      target.focus({preventScroll: true});
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    };
    if (form && input && status) {
      input.addEventListener('input', filter);
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && input.value) { event.preventDefault(); reset(); }
      });
      clear?.addEventListener('click', () => { reset(); input.focus(); });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const count = filter();
        if (!input.value.trim() || !count) return;
        const first = cards.find((card) => !card.hidden)?.closest('[data-help-topic]');
        if (first) jumpTo(first);
      });
      filter();
    }
    root.querySelectorAll('[data-help-jump]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !root.contains(target)) return;
        event.preventDefault();
        reset();
        jumpTo(target);
        try { history.replaceState(null, '', link.hash); } catch (_) { /* Local previews may restrict history changes. */ }
      });
    });
  };
  const initializeWithin = (scope) => {
    if (scope.matches?.('[data-ev-product-help]')) initialize(scope);
    scope.querySelectorAll('[data-ev-product-help]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document), {once:true});
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
